// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/Modal/EditorFieldInputNextStepWarningModal/index.tsx

import { useState } from 'react';

import RequesterFieldHasEmptyValueConfirmModal from '@app/components/Modal/RequesterFieldHasEmptyValueConfirmModal';
import SignersWithoutSignatureFieldConfirmModal from '@app/features/apply-react-signing/components/Modal/SignersWithoutSignatureFieldConfirmModal';
import SignerWithRequiredFieldCount from '@app/features/apply-react-signing/components/Modal/SignerWithoutSignatureField';

interface EditorFieldInputNextStepWarningModalProps {
  hasRequesterFieldEmptyValue: boolean;
  signerTotalCount: number;
  signersWithoutSignatureField: Array<SignerWithRequiredFieldCount>;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function EditorFieldInputNextStepWarningModal({
  hasRequesterFieldEmptyValue,
  signersWithoutSignatureField,
  signerTotalCount,
  onCancel,
  onConfirm,
}: EditorFieldInputNextStepWarningModalProps) {
  const [openModal, setOpenModal] = useState<
    'RequesterFieldHasEmptyValueConfirm' | 'SignerHasNotFieldsConfirm' | null
  >(() => {
    if (hasRequesterFieldEmptyValue) {
      return 'RequesterFieldHasEmptyValueConfirm';
    }

    if (signersWithoutSignatureField.length > 0) {
      return 'SignerHasNotFieldsConfirm';
    }

    return null;
  });

  return (
    <>
      {openModal && (
        <RequesterFieldHasEmptyValueConfirmModal
          isOpen={openModal === 'RequesterFieldHasEmptyValueConfirm'}
          onClose={() => {
            setOpenModal(null);
            onCancel();
          }}
          onConfirm={() => {
            if (signersWithoutSignatureField.length > 0) {
              setOpenModal('SignerHasNotFieldsConfirm');
            } else {
              setOpenModal(null);
              onConfirm();
            }
          }}
        />
      )}
      {openModal && (
        <SignersWithoutSignatureFieldConfirmModal
          isOpen={openModal === 'SignerHasNotFieldsConfirm'}
          signerTotalCount={signerTotalCount}
          signersWithoutSignatureField={signersWithoutSignatureField}
          onCancelClick={() => {
            setOpenModal(null);
            onCancel();
          }}
          onConfirmClick={() => {
            setOpenModal(null);
            onConfirm();
          }}
        />
      )}
    </>
  );
}
